import { render, staticRenderFns } from "./AutoAssign.vue?vue&type=template&id=2f316a2f&"
import script from "./AutoAssign.vue?vue&type=script&lang=ts&"
export * from "./AutoAssign.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports